module.exports = __webpack_public_path__ + "44cff3ae586d1b42e6dec109148ea245.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key_art-768-7.jpg
// module id = 441
// module chunks = 0